import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);

export const ease = CustomEase.create('custom', '0.58, -0.01, 0.26, 0.87');
